// ── Date / time formatting ──────────────────────────────────────

export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  let date = new Date(dateString).toLocaleDateString(undefined, options);
  if (date === "Invalid Date") {
    return "--";
  }
  return date;
};

export const formatTimestamp = (dateString) => {
  if (!dateString) return "--";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "--";
  return d.toISOString();
};

// ── Field resolution (defensive — handles multiple API shapes) ────

export const pinLabel = (pin) => (pin?.pin || pin?.pinCode || "—");

export const statusLabel = (pin) =>
  pin?.status || pin?.status_value || "UNKNOWN";

export const examTypeLabel = (pin) =>
  pin?.examType || pin?.exam_type || pin?.type || "—";

export const orderReference = (pin) =>
  pin?.order?.reference || pin?.orderReference || pin?.reference || "--";

// ── Badge / styling helpers ───────────────────────────────────────

export const statusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "AVAILABLE":
    case "SENT":
      return "bg-emerald-100 text-emerald-700";
    case "SOLD":
      return "bg-blue-100 text-blue-700";
    case "USED":
      return "bg-violet-100 text-violet-700";
    case "EXPIRED":
      return "bg-slate-100 text-slate-700";
    case "FAILED":
      return "bg-red-100 text-red-700";
    default:
      return "bg-slate-100 text-slate-600";
  }
};

export const examTypeBadgeClass = (examType) => {
  const normalized = String(examType || "").toUpperCase();
  if (normalized.includes("WAEC")) return "bg-amber-100 text-amber-700";
  if (normalized.includes("NECO")) return "bg-indigo-100 text-indigo-700";
  if (normalized.includes("NABTEB")) return "bg-fuchsia-100 text-fuchsia-700";
  return "bg-slate-100 text-slate-600";
};

// ── Common filter options ─────────────────────────────────────────

export const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "AVAILABLE", label: "Available" },
  { value: "SOLD", label: "Sold" },
];

export const EXAM_TYPE_OPTIONS = [
  { value: "", label: "All Exam Types" },
  { value: "WAEC", label: "WAEC" },
  { value: "NECO", label: "NECO" },
  { value: "NABTEB", label: "NABTEB" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
];

/**
 * Resolve a price value from the various shapes GET /api/admin/exam-pins/price
 * may return, e.g. `1000`, `{ price: 1000, examType: "NECO" }`,
 * `{ data: { price: 1000 } }` or a per-type map `{ WAEC: 2000, NECO: 1000 }`.
 */
export const resolvePinPrice = (payload, examType) => {
  if (payload === null || payload === undefined) return "";
  const d = payload.data ?? payload;
  if (typeof d === "number") return String(d);
  if (typeof d === "string") return d;
  if (typeof d === "object") {
    if (d.price !== undefined && d.price !== null) return String(d.price);
    if (d.amount !== undefined && d.amount !== null) return String(d.amount);
    if (examType && d[examType] !== undefined && d[examType] !== null) {
      return String(d[examType]);
    }
    const first = Object.values(d).find((v) => typeof v === "number");
    if (first !== undefined) return String(first);
  }
  return "";
};
